import { useMemo, useState } from 'react';

import CitiesSelector from '../CitiesSelector';
import CustomTextInput from '../CustomTextInput';
import SelectControlled from '../SelectControlled';
import {
  FISCAL_RESPONSIBILITIES,
  PERSON_TYPE_OPTIONS,
  ID_TYPE_OPTIONS
} from '../../screens/SaleTicket/constants';
import { getSiigoCustomer } from '../../../config/services/customers';
import useLoading from '../../../hooks/useLoading';

function BillingForm({ commonProps, getValues, setValue, watch }) {
  const [isLoading, setIsLoading] = useState(false);
  const renderPersonTypes = useMemo(
    () =>
      PERSON_TYPE_OPTIONS.map(option => (
        <option
          value={option.value}
          key={option.value}>{`${option.text}`}</option>
      )),
    []
  );

  const renderIdTypes = useMemo(
    () =>
      ID_TYPE_OPTIONS.map(option => (
        <option
          value={option.value}
          key={option.value}>{`${option.text}`}</option>
      )),
    []
  );

  const handleBlur = async () => {
    const identification = getValues('identification');
    if (identification) {
      setIsLoading(true);
      const siigoCustomer = await getSiigoCustomer(identification);

      if (siigoCustomer.ok) {
        if (Array.isArray(siigoCustomer.data.name)) {
          setValue('name', siigoCustomer.data.name[0]);
          setValue('last_name', siigoCustomer.data.name[1]);
        } else {
          setValue('name', siigoCustomer.data.name);
        }
        setValue('person_type', siigoCustomer.data.person_type);
        setValue('vat_responsible', siigoCustomer.data.vat_responsible);
        setValue('id_type', siigoCustomer.data.id_type.code);
        setValue('check_digit', siigoCustomer.data.check_digit);
        setValue('email', siigoCustomer.data.contacts[0].email);
        setValue('phone', siigoCustomer.data.phones[0].number);
        setValue('address', siigoCustomer.data.address.address);
        setValue(
          'fiscal_responsibilities',
          siigoCustomer.data.fiscal_responsibilities[0].code
        );
        setValue('state_code', siigoCustomer.data.address.city.state_code);
        setValue('city_code', siigoCustomer.data.address.city.city_code);
        setValue('vat_responsible', siigoCustomer.data.vat_responsible ? 1 : 0);
      } else {
        setValue('name', '');
        setValue('last_name', '');
        setValue('person_type', '');
        setValue('vat_responsible', '');
        setValue('id_type', '');
        setValue('check_digit', '');
        setValue('email', '');
        setValue('phone', '');
        setValue('address', '');
        setValue('fiscal_responsibilities', '');
        setValue('state_code', '');
        setValue('city_code', '');
        setValue('vat_responsible', '');
      }
      setIsLoading(false);
    }
  };

  useLoading(isLoading);

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="card p-3">
          <div className="mb-3 d-flex gap-2">
            <CustomTextInput
              name={'identification'}
              title={'CÉDULA'}
              {...commonProps}
              column="col-md-10"
              onBlur={handleBlur}
            />
            <CustomTextInput
              name={'check_digit'}
              title={'DV'}
              {...commonProps}
              column="col-md-2"
            />
            <CustomTextInput
              name={'type'}
              type={'hidden'}
              value={'Customer'}
              {...commonProps}
            />
          </div>
          <div className="mb-3">
            <SelectControlled
              name={'person_type'}
              title={'TIPO'}
              {...commonProps}
              options={renderPersonTypes}
            />
          </div>
          <div className="mb-3">
            <SelectControlled
              name={'id_type'}
              title={'TIPO DE DOCUMENTO'}
              {...commonProps}
              options={renderIdTypes}
            />
          </div>

          <CustomTextInput name={'name'} {...commonProps} title={'NOMBRE'} />
          <CustomTextInput
            name={'last_name'}
            {...commonProps}
            title={'APELLIDO'}
          />
          <CustomTextInput name={'phone'} {...commonProps} title={'TELÉFONO'} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="card p-3">
          <CitiesSelector controlledProps={commonProps} watch={watch} />
          <CustomTextInput
            name={'address'}
            {...commonProps}
            title={'DIRECCIÓN'}
          />
          <CustomTextInput name={'email'} {...commonProps} title={'EMAIL'} />
          <SelectControlled
            name={'vat_responsible'}
            title={'RESPONSABLE IVA'}
            {...commonProps}
            options={[
              <option key={1} value={1}>
                Si
              </option>,
              <option key={2} value={0}>
                No
              </option>
            ]}
          />
          <h6 className="mt-3">Responsabilidad fiscal</h6>
          <p className="small">
            Verifica la responsabilidad en el RUT de tu cliente, mínimo asignar
            R-99-PN
          </p>
          <div className="mb-3">
            <SelectControlled
              name={'fiscal_responsibilities'}
              title={'RESPONSABILIDAD FISCAL'}
              {...commonProps}
              options={FISCAL_RESPONSIBILITIES.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.text}
                </option>
              ))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BillingForm;
